(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener(
        'change',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }, 300),
      );
    }
  }
  customElements.define('cart-note', CartNote);

  const cartForm = document.getElementById('cart');
  const shippingDetailsRadios = document.querySelectorAll('input[name="shipping-details-option"]');
  const serviceNeedsCheckboxes = document.querySelectorAll('.cart-service-need');
  const noExtraServicesCheckbox = document.getElementById('service-no-extra-services');
  const cartErrors = document.getElementById('cart-errors');

  const submitFormWithSubmitter = (form, submitter) => {
    if (submitter?.name) {
      const hiddenSubmitterInput = document.createElement('input');
      hiddenSubmitterInput.type = 'hidden';
      hiddenSubmitterInput.name = submitter.name;
      hiddenSubmitterInput.value = submitter.value || '';
      form.appendChild(hiddenSubmitterInput);
    }
    HTMLFormElement.prototype.submit.call(form);
  };

  const validateServiceSelection = () => {
    const hasSelectedService = Array.from(serviceNeedsCheckboxes).some((checkbox) => checkbox.checked);
    const validationMessage = hasSelectedService
      ? ''
      : 'Please select at least one option under "What service do you need?".';

    serviceNeedsCheckboxes.forEach((checkbox) => {
      checkbox.required = false;
      checkbox.setCustomValidity('');
    });
    if (serviceNeedsCheckboxes.length && !hasSelectedService) {
      serviceNeedsCheckboxes[0].required = true;
      serviceNeedsCheckboxes[0].setCustomValidity(validationMessage);
    }
    if (cartErrors) {
      cartErrors.textContent = hasSelectedService ? '' : validationMessage;
    }
    return hasSelectedService;
  };

  const syncCartShippingServiceNow = (target) => {
    if (window.handleCartShippingServiceOptionChange) {
      window.handleCartShippingServiceOptionChange(target);
      return;
    }

    const shipping =
      document.querySelector('input[name="shipping-details-option"]:checked')?.value || '';
    const services = Array.from(document.querySelectorAll('.cart-service-need:checked'))
      .map((checkbox) => checkbox.value)
      .join(', ');

    if (window.persistAndSyncCartShippingServiceSelection) {
      window.persistAndSyncCartShippingServiceSelection(shipping, services, { immediate: true });
    }
  };

  serviceNeedsCheckboxes.forEach((checkbox) => {
    checkbox.addEventListener('change', (event) => {
      if (!serviceNeedsCheckboxes.length) return;

      if (event.target === noExtraServicesCheckbox && noExtraServicesCheckbox.checked) {
        serviceNeedsCheckboxes.forEach((item) => {
          if (item !== noExtraServicesCheckbox) item.checked = false;
        });
      } else if (event.target !== noExtraServicesCheckbox && event.target.checked && noExtraServicesCheckbox) {
        noExtraServicesCheckbox.checked = false;
      }

      validateServiceSelection();
      syncCartShippingServiceNow(event.target);
    });
  });

  shippingDetailsRadios.forEach((radio) => {
    radio.addEventListener('change', (event) => {
      syncCartShippingServiceNow(event.target);
    });
  });

  if (cartForm && shippingDetailsRadios.length) {
    cartForm.addEventListener('submit', async (event) => {
      event.preventDefault();

      if (window.cartShippingServiceUpdateDepth > 0) {
        return;
      }

      const submitter = event.submitter;
      if (!validateServiceSelection()) {
        serviceNeedsCheckboxes[0]?.reportValidity();
        return;
      }

      if (!cartForm.reportValidity()) {
        return;
      }

      submitFormWithSubmitter(cartForm, submitter);
    });
  }

  } catch(e) { console.error(e); }
})();
})();
